import StreetView from 'app/client/google/StreetView';
import * as styles from './mediaCenter.styles';

type StreetViewTabProps = {
  lat: number;
  lon: number;
};

export const StreetViewTab = ({ lat, lon }: StreetViewTabProps) => {
  return (
    <div
      role="tabpanel"
      id="tabpanel-streetview"
      aria-labelledby="tab-streetview"
      className={styles.streetViewContainer}
    >
      <div className={styles.streetViewInner}>
        <StreetView lat={lat} lng={lon} />
      </div>
    </div>
  );
};
